import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { companyProfile, navigationLinks } from '../content/siteContent';

function AdmissionHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="ca-header">
      <div className="ca-container ca-header__inner">
        <Link to="/" className="ca-brand" onClick={() => setOpen(false)}>
          <img src="/logo.jpg" alt="Vedanskrix logo" />
          <div>
            <strong>{companyProfile.brandName}</strong>
            <span>{companyProfile.tagline}</span>
          </div>
        </Link>

        <button
          type="button"
          className="ca-header__toggle"
          onClick={() => setOpen((current) => !current)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={open ? 'ca-header__nav ca-header__nav--open' : 'ca-header__nav'} aria-label="College admission navigation">
          {navigationLinks.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) => (isActive ? 'ca-header__link ca-header__link--active' : 'ca-header__link')}
            >
              {item.label}
            </NavLink>
          ))}
          <Link to="/contact" className="ca-header__cta" onClick={() => setOpen(false)}>
            Book Counselling
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default AdmissionHeader;
